import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface TagProps {
  children: ReactNode;
  className?: string;
}

// Small red-on-paper pill label (the preview's `.tag`): "Example",
// "General cashback model" and similar.
const Tag = ({ children, className }: TagProps) => (
  <span
    className={cn(
      "inline-block self-start rounded-full border border-line-warm bg-paper px-3 py-1 text-[13px] leading-normal font-semibold text-primary",
      className,
    )}
  >
    {children}
  </span>
);

export default Tag;
